import { COUNTRIES_PHONE_PREFIX } from '@app/core/constants/countries-phone-prefix';
import { SelectOption } from '@shared/components/select';

export const getPhonePrefixOptions = (): SelectOption[] => {
  return COUNTRIES_PHONE_PREFIX.filter(
    ({ prefixPhone }) => prefixPhone !== null,
  ).map(({ name, prefixPhone, code }) => ({
    label: `${name} (${prefixPhone})`,
    value: code || '',
  }));
};
